if (!customElements.get('util-flyout')) {
  class UtilFlyout extends HTMLElement {
    constructor() {
      super();
      this.activePanel = null;
      this.activeTrigger = null;
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onLinkClick = this.onLinkClick.bind(this);
    }

    connectedCallback() {
      this.triggers = this.querySelectorAll('.flyout-trigger');
      this.container = this.container || this.querySelector('.flyout-container');
      if (!this.container) return;

      // Move panels to body so position: fixed isn't affected by transformed/sticky ancestors
      document.body.appendChild(this.container);

      if (this.initialized) return;
      this.initialized = true;
      this.replaceSeparators();
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', () => this.open(trigger));
      });
      this.container.querySelectorAll('[data-flyout-close]').forEach(el => {
        el.addEventListener('click', () => this.close());
      });

      // Links elsewhere on the page with href="#_<handle>" open the matching flyout
      document.addEventListener('click', this.onLinkClick);
      this.openFromHash(window.location.hash);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onLinkClick);
      if (this.activePanel) this.close();
      if (this.container) this.container.remove();
    }

    // Merchants type "---" on its own line in the description to add a separator.
    // Check text content since the editor may wrap it in spans.
    replaceSeparators() {
      this.container.querySelectorAll('.flyout-content p').forEach(p => {
        if (p.textContent.trim() === '---') p.replaceWith(document.createElement('hr'));
      });
    }

    open(trigger) {
      var panel = this.container.querySelector('#' + trigger.getAttribute('aria-controls'));
      if (!panel) return;
      if (this.activePanel) this.close();

      this.activePanel = panel;
      this.activeTrigger = trigger;
      panel.querySelector('.flyout-content').scrollTop = 0;
      this.container.classList.add('is-open');
      panel.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('flyout-open');
      document.addEventListener('keydown', this.onKeyDown);
      $s.trapFocus(panel, panel.querySelector('.flyout-close'));
    }

    close() {
      if (!this.activePanel) return;
      this.container.classList.remove('is-open');
      this.activePanel.classList.remove('is-open');
      this.activeTrigger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('flyout-open');
      document.removeEventListener('keydown', this.onKeyDown);
      this.activePanel = null;
      this.activeTrigger = null;
      $s.removeTrapFocus();
    }

    getTriggerByHash(hash) {
      if (!hash || hash.indexOf('#_') !== 0) return null;
      var handle = decodeURIComponent(hash.slice(2)).toLowerCase();
      return Array.prototype.find.call(this.triggers, trigger => trigger.dataset.flyoutHandle === handle) || null;
    }

    openFromHash(hash) {
      var trigger = this.getTriggerByHash(hash);
      if (trigger) this.open(trigger);
      return !!trigger;
    }

    onLinkClick(e) {
      var link = e.target.closest('a[href*="#_"]');
      if (!link || link.pathname !== window.location.pathname) return;
      if (this.openFromHash(link.hash)) e.preventDefault();
    }

    onKeyDown(e) {
      if (e.key === 'Escape') this.close();
    }
  }
  customElements.define('util-flyout', UtilFlyout);
}
